import type { NeedAccessProps } from './need-access.component';

/**
 * Maps HTML attribute names (kebab-case) to PromotedProductsComponent prop names (camelCase)
 */
export const NEED_ACCESS_ATTRIBUTE_MAP: Record<string, keyof NeedAccessProps> = {
  'content-id': 'contentId',
  'content-type': 'contentType',
  'title-text': 'titleText',
  'title-size': 'titleSize',
  description: 'description',
  'max-width': 'maxWidth',
  'column-count': 'columnCount',
  'card-border-width': 'cardBorderWidth',
  'card-border-radius': 'cardBorderRadius',
  'card-border-color': 'cardBorderColor',
  'card-background-color': 'cardBackgroundColor',
  'card-text-color': 'cardTextColor',
  'card-badge-background-color': 'cardBadgeBackgroundColor',
  'vertical-padding': 'verticalPadding',
  'horizontal-padding': 'horizontalPadding',
};

/**
 * Extracts attributes from an HTMLElement and converts them to CollectiblesComponent props
 */
export function extractNeedAccessAttributes(element: HTMLElement): Partial<NeedAccessProps> {
  const props: Partial<NeedAccessProps> = {};

  for (const [attrName, propName] of Object.entries(NEED_ACCESS_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = value;
    }
  }

  return props;
}
